import { Link } from 'react-router-dom';
import { SELLER, SellerContacts } from './sellerInfo';

export default function Privacy() {
  const s = SELLER;

  return (
    <div className="container page" style={{ textAlign: 'left' }}>
      <h1>Политика конфиденциальности и обработки персональных данных</h1>

      <p>
        Настоящая политика определяет порядок обработки и защиты персональных данных пользователей
        сайта интернет‑магазина {s.brand} ({s.site}) (далее — «Сайт») оператором — {s.fullName}{' '}
        (далее — «Оператор», «Продавец»).
      </p>

      <SellerContacts />

      <p>
        Оператор направляет в Роскомнадзор уведомление об обработке персональных данных. Сведения
        включаются в реестр операторов по результатам рассмотрения. Номер уведомления будет указан
        здесь после внесения в реестр.
      </p>

      <section>
        <h2>1. Нормативные основания</h2>
        <p>
          Политика разработана в соответствии с Федеральным законом от 27.07.2006 № 152‑ФЗ
          «О персональных данных», Законом РФ «О защите прав потребителей», Гражданским кодексом РФ
          и иными нормативными актами Российской Федерации.
        </p>
      </section>

      <section>
        <h2>2. Категории субъектов и состав данных</h2>
        <p>Оператор обрабатывает данные следующих категорий субъектов:</p>
        <ul>
          <li>посетители Сайта;</li>
          <li>зарегистрированные пользователи (покупатели);</li>
          <li>покупатели при оформлении заказов;</li>
          <li>подписчики информационных и рекламных рассылок (при отдельном согласии);</li>
          <li>представители оптовых клиентов (при подаче заявки на опт).</li>
        </ul>
        <p>В зависимости от сценария могут обрабатываться:</p>
        <ul>
          <li>ФИО / имя;</li>
          <li>номер телефона (аккаунт, заказ, связь по заказу, рассылки при согласии);</li>
          <li>адрес электронной почты;</li>
          <li>адрес доставки;</li>
          <li>сведения о заказе (состав, сумма, статус, способ получения);</li>
          <li>данные учётной записи (в том числе хэш пароля);</li>
          <li>токены подтверждения email и сброса пароля;</li>
          <li>сведения о бонусной программе (баланс, операции), если программа включена;</li>
          <li>
            реквизиты оптового клиента: наименование организации / ИП, ИНН, КПП, адрес, комментарий;
          </li>
          <li>
            технические данные: IP‑адрес, cookies, данные браузера и устройства, сведения о действиях
            на Сайте, идентификаторы счётчика Яндекс.Метрики (при согласии на аналитические cookie).
          </li>
        </ul>
        <p>
          Платежные данные банковских карт обрабатываются платёжным сервисом банка (Т‑Банк). Оператор
          не получает и не хранит полные реквизиты банковских карт.
        </p>
        <p>
          Специальные категории персональных данных и биометрические персональные данные Оператор не
          обрабатывает.
        </p>
      </section>

      <section>
        <h2>3. Цели обработки</h2>
        <ul>
          <li>регистрация и аутентификация, работа личного кабинета;</li>
          <li>оформление и исполнение договоров купли‑продажи, доставка и самовывоз;</li>
          <li>связь по заказу, претензиям, гарантии и возврату (телефон, SMS, email);</li>
          <li>приём оплаты и направление кассовых чеков;</li>
          <li>начисление и учёт бонусов (если программа используется);</li>
          <li>рассмотрение оптовых заявок и учёт реквизитов оптовых клиентов;</li>
          <li id="marketing">
            информационные и рекламные рассылки о товарах, акциях и спецпредложениях по email, SMS
            и мессенджерам — только при отдельном согласии, которое можно отозвать;
          </li>
          <li>обеспечение безопасности и работоспособности Сайта;</li>
          <li>
            веб‑аналитика посещаемости (Яндекс.Метрика) — при согласии на аналитические cookie;
          </li>
          <li>соблюдение требований законодательства РФ.</li>
        </ul>
      </section>

      <section>
        <h2>4. Правовые основания</h2>
        <ul>
          <li>
            заключение и исполнение договора, стороной которого является субъект (заказ, личный
            кабинет);
          </li>
          <li>
            согласие субъекта (регистрация, аналитические cookie, рекламные рассылки);
          </li>
          <li>
            исполнение обязанностей Оператора, установленных законом (ККТ, бухгалтерский и налоговый
            учёт);
          </li>
          <li>законный интерес Оператора (безопасность Сайта, предотвращение злоупотреблений).</li>
        </ul>
      </section>

      <section>
        <h2>5. Действия с персональными данными</h2>
        <p>
          Оператор осуществляет: сбор, запись, систематизацию, накопление, хранение, уточнение
          (обновление, изменение), извлечение, использование, передачу (предоставление, доступ),
          блокирование, удаление и уничтожение персональных данных. Обработка автоматизированная и
          смешанная (в том числе переписка и звонки менеджера по заказам).
        </p>
      </section>

      <section>
        <h2>6. Передача третьим лицам</h2>
        <p>
          Данные передаются строго в объёме, необходимом для указанных целей:
        </p>
        <ul>
          <li>АО «ТБанк» — оплата заказов и кассовые чеки;</li>
          <li>ООО «Юнисендер СМАРТ» (Unisender Go) — служебные письма и, при согласии, рассылки;</li>
          <li>ООО «Яндекс» — Яндекс.Метрика при согласии на аналитические cookie;</li>
          <li>
            ООО «РЕГИСТРАТОР ДОМЕННЫХ ИМЕН РЕГ.РУ» (REG.RU / REG.Облако) — размещение Сайта и баз
            данных, серверы в Москве;
          </li>
          <li>службы доставки / транспортные компании — доставка конкретного заказа;</li>
          <li>операторы фискальных данных — в рамках применения ККТ;</li>
          <li>подрядчики техподдержки Сайта — при наличии договора поручения;</li>
          <li>государственные органы — при наличии законных оснований.</li>
        </ul>
        <p>
          SMS‑провайдер подключается при фактической отправке SMS (сервисные сообщения или рассылки
          при согласии). Реквизиты такого подрядчика будут отражены в договоре и при необходимости
          в уведомлении в Роскомнадзор.
        </p>
      </section>

      <section>
        <h2>7. Место обработки и трансграничная передача</h2>
        <p>
          Запись, систематизация, накопление, хранение, уточнение и извлечение персональных данных
          граждан РФ осуществляются с использованием баз данных на территории Российской Федерации
          (ст. 18 ч. 5 152‑ФЗ), за исключением случаев, прямо предусмотренных законом.
        </p>
        <p>
          Трансграничная передача персональных данных Оператором не осуществляется. Если передача
          потребуется, Оператор обеспечит соблюдение требований 152‑ФЗ до её начала.
        </p>
      </section>

      <section>
        <h2>8. Сроки хранения</h2>
        <ul>
          <li>
            учётная запись, телефон и email в ней — пока аккаунт активен и разумный срок после
            удаления / по запросу субъекта (если закон не требует дольше);
          </li>
          <li>
            заказы, расчёты и реквизиты оптовиков — сроки бухгалтерского и налогового учёта (как
            правило, не менее 5 лет);
          </li>
          <li>согласие на рекламные рассылки — до отзыва согласия;</li>
          <li>данные Яндекс.Метрики — по настройкам счётчика и пока нужны для аналитики;</li>
          <li>токены подтверждения email и сброса пароля — до истечения срока действия;</li>
          <li>технические логи и необходимые cookies — не дольше, чем нужно для работы и безопасности Сайта.</li>
        </ul>
        <p>
          По достижении целей обработки либо по законному требованию субъекта данные уничтожаются
          или обезличиваются, если хранение не требуется законом.
        </p>
      </section>

      <section>
        <h2>9. Права субъекта персональных данных</h2>
        <p>Вы вправе:</p>
        <ul>
          <li>получать сведения об обработке своих персональных данных;</li>
          <li>требовать уточнения, блокирования или удаления данных при наличии оснований;</li>
          <li>отозвать согласие на обработку, если обработка основана на согласии;</li>
          <li>отозвать согласие на рекламные рассылки (личный кабинет или запрос на email);</li>
          <li>обжаловать действия или бездействие Оператора в Роскомнадзор или в суд.</li>
        </ul>
        <p>
          Запрос направьте на e‑mail:{' '}
          <a href={`mailto:${s.email}`}>{s.email}</a>. Укажите ФИО, контакт для ответа и суть
          требования. Оператор отвечает в срок, не превышающий 30 дней с момента получения запроса
          (если иной срок не установлен законом).
        </p>
      </section>

      <section id="cookies">
        <h2>10. Cookies и аналогичные технологии</h2>
        <p>
          Подробнее — в <Link to="/cookies">политике cookie</Link>. Кратко:
        </p>
        <ul>
          <li>необходимые cookie — работа Сайта, корзина, вход, безопасность;</li>
          <li>
            аналитические cookie (Яндекс.Метрика, включая карту кликов и вебвизор) — только после
            согласия в баннере cookie («Принять все»).
          </li>
        </ul>
        <p>
          Рекламные пиксели сторонних рекламных сетей на Сайте не используются.
        </p>
      </section>

      <section>
        <h2>11. Меры защиты</h2>
        <p>
          Применяются организационные и технические меры: ограничение доступа по ролям, HTTPS,
          хеширование паролей, хранение на серверах в РФ, защита сессий.
        </p>
      </section>

      <section>
        <h2>12. Изменение политики</h2>
        <p>
          Оператор вправе вносить изменения в настоящую политику. Актуальная версия размещается на
          Сайте. Продолжение использования Сайта после публикации новой редакции означает
          ознакомление с ней в части, не требующей отдельного согласия (реклама и аналитика по‑прежнему
          только при отдельном согласии).
        </p>
      </section>

      <p>
        См. также: <Link to="/oferta">публичная оферта</Link>,{' '}
        <Link to="/cookies">политика cookie</Link>,{' '}
        <Link to="/delivery">доставка и возврат</Link>, <Link to="/contacts">контакты</Link>,{' '}
        <Link to="/return-memo">памятка о возврате</Link>.
      </p>

      <p style={{ opacity: 0.8, marginTop: 24 }}>
        © {new Date().getFullYear()} {s.name}. Последнее обновление: {s.updatedAt}
      </p>
    </div>
  );
}
